import { render, staticRenderFns } from "./SectionContextMenu.vue?vue&type=template&id=e8252808&scoped=true"
import script from "./SectionContextMenu.vue?vue&type=script&lang=js"
export * from "./SectionContextMenu.vue?vue&type=script&lang=js"
import style0 from "./SectionContextMenu.vue?vue&type=style&index=0&id=e8252808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8252808",
  null
  
)

export default component.exports